import { AutomationStep } from '@/types/automationSteps.ts';
import { Stack } from '@mantine/core';
import { useUpdateStepFields } from '@/hooks/api/steps/useUpdateStepFields.ts';
import StyledTextInput from '@/components/StyledInputFields/StyledTextInput.tsx';
import { StepErrorType } from '@/types/stepErrorTypes.ts';
import useStepSpecificError from '@/hooks/useStepSpecificError.ts';
import { STEP_NAME_MAX_LENGTH } from '@/utils/constants.ts';

type props = {
  step: AutomationStep;
  nameLabel: string;
};

type CommonFields = {
  name: string;
  description: string;
};

const StepCommonFields = ({ step, nameLabel }: props) => {
  const { fields, onChange } = useUpdateStepFields<CommonFields>({ step });

  const nameError = useStepSpecificError(step, StepErrorType.EmptyStepName);

  return (
    <Stack w={'100%'}>
      <StyledTextInput
        label={nameLabel}
        value={fields.name}
        placeholder="Step Name"
        onChange={(event) => {
          const value = event.currentTarget.value.replace(/[/\n]/g, '');
          onChange({ name: value });
        }}
        required={true}
        maxLength={STEP_NAME_MAX_LENGTH}
        error={nameError}
      />
    </Stack>
  );
};

export default StepCommonFields;
